import styled from 'styled-components';

const PearlConnectFlowLoaderStyled = styled.div`
    position: fixed;
    inset: 0;
    z-index: 999;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: transparent;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
`;

export { PearlConnectFlowLoaderStyled };
